export default __webpack_public_path__ + "static/ps-729ff122b21d0bb4bae5d45747b053a6.svg";